import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

interface Props {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
}

const AnalyseButton: React.FC<Props> = ({ disabled, loading, onClick }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 1,
      paddingBottom: 4,
    }}
  >
    <Button
      variant="contained"
      size="medium"
      onClick={onClick}
      disabled={disabled || loading}
      sx={{
        background: 'linear-gradient(to right, #F39A81, #959BEA)',
        color: 'white',
        fontFamily: 'MuseoModerno',
        fontWeight: 600,
        fontSize: '48px',
        width: '900px',
        height: '130px',
        borderRadius: '30px',
        textTransform: 'none',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        '&:hover': {
          background: 'linear-gradient(to right, #e88972, #7d84d8)',
          boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
        },
        '&:disabled': {
          background: '#e0e0e0',
          color: '#999',
        },
      }}
    >
      {loading ? <CircularProgress size={32} sx={{ color: 'white' }} /> : 'Analyse'}
    </Button>
  </Box>
);

export default AnalyseButton;
